/*! Pushy - v1.1.0 - 2017-1-30
* Pushy is a responsive off-canvas navigation menu using CSS transforms & transitions.
* https://github.com/christophery/pushy/
* by Christopher Yee */

/* UPDATED by CM on 3/21/2025 - Added focus trap */

(function ($) {
    var pushy = $('.pushy'), //menu css class
        body = $('body'),
        container = $('#container'), //container css class
        push = $('.push'), //css class to add pushy capability
        pushyLeft = 'pushy-left', //css class for left menu position
        pushyOpenLeft = 'pushy-open-left', //css class when menu is open (left position)
        pushyOpenRight = 'pushy-open-right', //css class when menu is open (right position)
        siteOverlay = $('.site-overlay'), //site overlay
        menuBtn = $('.menu-btn, .pushy-link'), //css classes to toggle the menu
        menuBtnFocus = $('#js-mobile-nav-button'), //element to refocus when menu is closed
        menuLinkFocus = $(pushy.data('focus')), //focus on link when menu is open
        menuSpeed = 200, //jQuery fallback menu speed
        menuWidth = pushy.width() + 'px', //jQuery fallback menu width
        submenuClass = '.pushy-submenu',
        submenuOpenClass = 'pushy-submenu-open',
        submenuClosedClass = 'pushy-submenu-closed',
        submenu = $(submenuClass);

    // ======== FOCUS TRAP ========
    let trapFocusHandler;

    function trapFocus(container) {
        if (!body.hasClass(pushyOpenLeft) && !body.hasClass(pushyOpenRight)) return;

        const focusableSelectors = 'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
        const focusableEls = container.find(focusableSelectors).filter(':visible');
        const firstEl = focusableEls.first()[0];
        const lastEl = focusableEls.last()[0];

        trapFocusHandler = function (e) {
            if (e.key === 'Tab') {
                if (e.shiftKey && document.activeElement === firstEl) {
                    e.preventDefault();
                    lastEl.focus();
                } else if (!e.shiftKey && document.activeElement === lastEl) {
                    e.preventDefault();
                    firstEl.focus();
                }
            }
        };

        container[0].addEventListener('keydown', trapFocusHandler);
        firstEl?.focus();
    }

    function releaseFocus(container) {
        if (trapFocusHandler) {
            container[0].removeEventListener('keydown', trapFocusHandler);
            trapFocusHandler = null;
        }

        if (menuBtnFocus && menuBtnFocus.length) {
            menuBtnFocus.focus();
        }
    }
    // =============================

    //close menu w/ esc key
    $(document).keyup(function (e) {
        if (e.keyCode == 27) {
            if (body.hasClass(pushyOpenLeft) || body.hasClass(pushyOpenRight)) {
                if (cssTransforms3d) {
                    closePushy();
                } else {
                    closePushyFallback();
                    opened = false;
                }
            }
        }
    });

    function setAriaAttributes() {
        var mobileButton = $('.menu-btn');
        if (body.hasClass(pushyOpenRight)) {
            $(mobileButton).attr('aria-expanded', 'false');
            $(".close-pushy").attr('aria-expanded', 'false');
            $("#main-nav-announcement").text("Main navigation closed");
        } else {
            $(mobileButton).attr('aria-expanded', 'true');
            $(".close-pushy").attr('aria-expanded', 'true');
            $("#main-nav-announcement").text("Main navigation open");
        }
    }

    function togglePushy() {
        const isOpening = pushy.hasClass(pushyLeft)
            ? !body.hasClass(pushyOpenLeft)
            : !body.hasClass(pushyOpenRight);

        setAriaAttributes();

        if (pushy.hasClass(pushyLeft)) {
            body.toggleClass(pushyOpenLeft);
        } else {
            body.toggleClass(pushyOpenRight);
        }

        // Always bind transitionend but only act if it's an opening transition
        pushy.one('transitionend', function () {
            if (isOpening) {
                // Set initial focus inside menu
                const focusTarget = pushy.find('a, button, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
                focusTarget?.focus();
                trapFocus(pushy);
            } else {
                releaseFocus(pushy);
            }
        });
    }

    function closePushy() {
        setAriaAttributes();
        releaseFocus(pushy);

        if (pushy.hasClass(pushyLeft)) {
            body.removeClass(pushyOpenLeft);
        } else {
            body.removeClass(pushyOpenRight);
        }
    }

    function openPushyFallback() {
        setAriaAttributes();

        if (pushy.hasClass(pushyLeft)) {
            body.addClass(pushyOpenLeft);
            pushy.animate({ left: "0px" }, menuSpeed);
            container.animate({ left: menuWidth }, menuSpeed);
            push.animate({ left: menuWidth }, menuSpeed);
        } else {
            body.addClass(pushyOpenRight);
            pushy.animate({ right: '0px' }, menuSpeed);
            container.animate({ right: menuWidth }, menuSpeed);
            push.animate({ right: menuWidth }, menuSpeed);
        }

        if (menuLinkFocus.length) {
            menuLinkFocus.focus();
        }

        trapFocus(pushy);
    }

    function closePushyFallback() {
        setAriaAttributes();
        releaseFocus(pushy);

        if (pushy.hasClass(pushyLeft)) {
            body.removeClass(pushyOpenLeft);
            pushy.animate({ left: "-" + menuWidth }, menuSpeed);
            container.animate({ left: "0px" }, menuSpeed);
            push.animate({ left: "0px" }, menuSpeed);
        } else {
            body.removeClass(pushyOpenRight);
            pushy.animate({ right: "-" + menuWidth }, menuSpeed);
            container.animate({ right: "0px" }, menuSpeed);
            push.animate({ right: "0px" }, menuSpeed);
        }
    }

    function toggleSubmenu() {
        $(submenuClass).addClass(submenuClosedClass);

        $(submenuClass).on('click', function () {
            var selected = $(this);

            if (selected.hasClass(submenuClosedClass)) {
                $(submenuClass).addClass(submenuClosedClass).removeClass(submenuOpenClass);
                selected.removeClass(submenuClosedClass).addClass(submenuOpenClass);
            } else {
                selected.addClass(submenuClosedClass).removeClass(submenuOpenClass);
            }
        });
    }

    var cssTransforms3d = (function csstransforms3d() {
        var el = document.createElement('p'),
            supported = false,
            transforms = {
                'webkitTransform': '-webkit-transform',
                'OTransform': '-o-transform',
                'msTransform': '-ms-transform',
                'MozTransform': '-moz-transform',
                'transform': 'transform'
            };

        if (document.body !== null) {
            document.body.insertBefore(el, null);

            for (var t in transforms) {
                if (el.style[t] !== undefined) {
                    el.style[t] = 'translate3d(1px,1px,1px)';
                    supported = window.getComputedStyle(el).getPropertyValue(transforms[t]);
                }
            }

            document.body.removeChild(el);
            return (supported !== undefined && supported.length > 0 && supported !== "none");
        } else {
            return false;
        }
    })();

    if (cssTransforms3d) {
        toggleSubmenu();

        menuBtn.on('click', function () {
            togglePushy();
        });

        siteOverlay.on('click', function () {
            if (body.hasClass(pushyOpenLeft) || body.hasClass(pushyOpenRight)) {
                closePushy();
            }
        });
    } else {
        body.addClass('no-csstransforms3d');

        if (pushy.hasClass(pushyLeft)) {
            pushy.css({ left: "-" + menuWidth });
        } else {
            pushy.css({ right: "-" + menuWidth });
        }

        container.css({ "overflow-x": "hidden" });

        var opened = false;

        toggleSubmenu();

        menuBtn.on('click', function () {
            if (opened) {
                closePushyFallback();
                opened = false;
            } else {
                openPushyFallback();
                opened = true;
            }
        });

        siteOverlay.on('click', function () {
            if (opened) {
                closePushyFallback();
                opened = false;
            }
        });
    }
}(jQuery));